import React, { useEffect } from 'react';
import { Menu, MenuItem, Icon, Table } from 'semantic-ui-react';
import classNames from 'classnames';
import api from '../../api';
import Config from '../../constants/Config';
import styles from './PromotionStatistics.module.scss';

const promotionStatistics = React.memo(() => {
  const [currentSkip, setCurrrentSkip] = React.useState(1);
  const [listObj, setListObj] = React.useState({
    list: [],
    total: 0,
  });

  const init = React.useCallback(() => {
    api
      .getPromotionStatistics({
        limit: Config.AONNOUCEMENT_LIMIT,
        skip: currentSkip - 1,
      })
      .then((res) => {
        setListObj({ list: res.item, total: res.total });
      });
  }, [currentSkip]);
  useEffect(() => {
    init();
  }, [currentSkip, init]);
  return (
    <div className={styles.app}>
      <div className={styles.table}>
        <Table celled unstackable>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell width={2}>姓名</Table.HeaderCell>
              <Table.HeaderCell width={2}>推广码</Table.HeaderCell>
              <Table.HeaderCell width={2}>付款人数</Table.HeaderCell>
              <Table.HeaderCell width={2}>订单数</Table.HeaderCell>
              <Table.HeaderCell width={2}>付款金额</Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {!!listObj.list.length &&
              listObj.list.map((item) => (
                <Table.Row key={item.id}>
                  <Table.Cell>{item.name}</Table.Cell>
                  <Table.Cell>{item.promotionCode}</Table.Cell>
                  <Table.Cell>{item.numberOfPeopleSum}</Table.Cell>
                  <Table.Cell>{item.pays}</Table.Cell>
                  <Table.Cell>{item.paymentAmountSum}</Table.Cell>
                </Table.Row>
              ))}
          </Table.Body>
          <Table.Footer>
            <Table.Row>
              <Table.HeaderCell colSpan="5">
                <Menu floated="right" pagination>
                  <MenuItem
                    as="a"
                    icon
                    onClick={() => {
                      setCurrrentSkip((pre) => {
                        if (pre <= 1) {
                          return 1;
                        }
                        return pre - 1;
                      });
                    }}
                  >
                    <Icon name="chevron left" />
                  </MenuItem>
                  {Array.from({ length: listObj.total }, (_, index) => (
                    <MenuItem
                      as="a"
                      key={index}
                      className={classNames(index + 1 === currentSkip && styles.menuItemActive)}
                      onClick={() => {
                        setCurrrentSkip(index + 1);
                      }}
                    >
                      {index + 1}
                    </MenuItem>
                  ))}
                  <MenuItem
                    as="a"
                    icon
                    onClick={() => {
                      setCurrrentSkip((pre) => {
                        if (pre + 1 >= listObj.total) {
                          return listObj.total;
                        }
                        return pre + 1;
                      });
                    }}
                  >
                    <Icon name="chevron right" />
                  </MenuItem>
                </Menu>
              </Table.HeaderCell>
            </Table.Row>
          </Table.Footer>
        </Table>
      </div>
    </div>
  );
});

export default promotionStatistics;
